import { handleActions } from 'redux-actions'
import * as type from './type'


export const initialState = {
    messageList: [],
    email: null,
    fetching: false,
    error: null,
}


export default handleActions({
    [type.FIND_GMAIL_MESSAGES_REQUEST]: (state, action) => {
        return {
            ...state,
            messageList: [],
            email: null,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_GMAIL_MESSAGES_SUCCESS]: (state, action) => {
        const { email, messageList } = action.payload
        return {
            ...state,
            messageList,
            email,
            fetching: false,
        }
    },
    [type.FIND_GMAIL_MESSAGE_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            error,
            fetching: true,
        }
    },
    [type.TOGGLE_GMAIL_MESSAGE]: (state, action) => {
        const { messageId } = action.payload
        return {
            ...state,
            messageList: state.messageList.map(message => {
                return messageId !== message.id ? message : {
                    ...message,
                    open: !message.open,
                }
            }),
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/gmail/state/reducer.js